import { useEffect, useRef } from 'react';

import classNames from 'classnames';

import { events, messageBus } from '@schibsted-nmp/advertising-events';
import {
  AdObj,
  PlacementId,
  NativeAdObj,
  isNativeAd
} from '@schibsted-nmp/advertising-shared';

/**
 * Sets styling for both placement and it's container.
 * The placement is usually rendered right after the call of this hook.
 * The container is rendered a completely different place in the DOM and needs to
 * be retrieved by ID.
 */
export function usePlacementStyling(
  placementId: PlacementId,
  containerId: string,
  targetId: string,
  adObj?: AdObj,
  status?: string
) {
  const prevPublishedPayloadClassName = useRef<string>('');
  function getPlacementClassName(): string {
    if (placementId === PlacementId.Bottom1) return 'ml-auto overflow-hidden';
    if (placementId.includes('middle')) return 'mx-auto';
    return '';
  }

  useEffect(() => {
    function publishMessageBus(className: string, containerId: string) {
      if (prevPublishedPayloadClassName.current === className) return;
      prevPublishedPayloadClassName.current = className;
      messageBus.publish(
        events.COMPANION.channel,
        events.COMPANION.AD_STYLES.topic,
        events.COMPANION.AD_STYLES.sendPayload({
          className,
          containerId
        })
      );
    }
    if (adObj) {
      const className = classNames({
        loaded: status === 'available' || status === 'loaded',
        'native-ad': adObj && isNativeAd(adObj as NativeAdObj),
        'video-ad': adObj?.adType === 'video',
        'banner-ad':
          adObj &&
          !isNativeAd(adObj as NativeAdObj) &&
          adObj?.adType !== 'video',
        failed: status === 'failed'
      });

      publishMessageBus(className, containerId || `${placementId}--container`);
    } else if (status === 'failed') {
      publishMessageBus('failed', containerId || `${placementId}--container`);
    }
  }, [status, containerId, adObj, placementId, targetId]);

  return `relative ${getPlacementClassName()}`;
}
